import React from 'react'
import { useTranslation } from 'react-i18next'
import { Calculator, FileUp, FolderPlus } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface Props { onImport?: () => void; onAddGroup?: () => void }

const BudgetEmptyState: React.FC<Props> = ({ onImport, onAddGroup }) => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-md border py-16 text-muted-foreground">
      <Calculator className="h-12 w-12 opacity-40" />
      <p className="text-sm">{t('CostControl_budget_empty')}</p>
      {(onImport || onAddGroup) && (
        <div className="flex items-center gap-2">
          {onImport && (
            <Button variant="outline" size="sm" className="h-8" onClick={onImport}>
              <FileUp className="h-4 w-4" />
              {t('CostControl_import_open')}
            </Button>
          )}
          {onAddGroup && (
            <Button size="sm" className="h-8" onClick={onAddGroup}>
              <FolderPlus className="h-4 w-4" />
              {t('CostControl_add_level_one')}
            </Button>
          )}
        </div>
      )}
    </div>
  )
}
export default BudgetEmptyState
